export default __webpack_public_path__ + "static/media/Honggil_crop.504b65b2.jpg";